import { IndividualConfig, ToastContainerDirective } from 'ngx-toastr';

export type TranslationFunction = (message: string | ComplexTranslation) => string;

export interface ComplexTranslation {
  message: string;
  params: { [key: string]: string };
}
export interface CbreToastrOptions {
  inlineContainer: ToastContainerDirective;
  overrideConfig: Partial<IndividualConfig>;
}

export interface CbreToastrConfiguration {
  useInlineContainer: boolean;
  inlineContainer: ToastContainerDirective;
  toastrConfig: Partial<IndividualConfig>;
}

export interface ToastrType {
  toastClass: string;
  timeout?: number;
}

export interface CbreSnackBarOptions {
  duration: number;
  action: string;
}

/**
 * This interface is used internally
 */
export interface CbreSnackBarConfiguration {
  actionButton: string;
  duration: number;
  panelClass: string;
}

export const ToastrTypes: { [key: string]: ToastrType } = {
  error: {
    toastClass: 'border-red toast',
    timeout: 5000,
  },
  warning: {
    toastClass: 'toast border-yellow',
  },
  info: {
    toastClass: 'toast border-blue',
  },
  success: {
    toastClass: 'toast border-green',
  },
};

const defaultToastrConfig: Partial<IndividualConfig> = {
  closeButton: true,
  tapToDismiss: false,
  timeOut: 10000,
  easing: 'ease-in',
};

const defaultSnackBarConfig: CbreSnackBarConfiguration = {
  actionButton: 'Close',
  panelClass: undefined,
  duration: 2000,
};

export function mergeSnackBarDefaults(options: Partial<CbreSnackBarOptions> = {}): CbreSnackBarConfiguration {
  return {
    actionButton: options.action || defaultSnackBarConfig.actionButton,
    panelClass: defaultSnackBarConfig.panelClass,
    duration: options.duration || defaultSnackBarConfig.duration,
  };
}

export function mergeDefaults(
  toastrType: ToastrType,
  options: Partial<CbreToastrOptions> = {}
): CbreToastrConfiguration {
  const defaultTimeoutByType = toastrType.timeout ? { timeout: toastrType.timeout } : {};
  const finalToastrConfig: Partial<IndividualConfig> = Object.assign(
    {},
    defaultToastrConfig,
    { toastClass: toastrType.toastClass },
    defaultTimeoutByType,
    options.overrideConfig
  );

  return {
    useInlineContainer: options.inlineContainer != null,
    inlineContainer: options.inlineContainer,
    toastrConfig: finalToastrConfig,
  };
}
